import Alfredo from '../../assets/imagens/Alfredo.png'
import AnimacaoXp from  '../../components/ui/Animacao/AnimacaoXP'
import {motion} from 'motion/react'

import './Introducao.css'
export default function Introducao({children}){
    return (
            <div className="containerInicial">
                <motion.img
                    src={Alfredo}
                    className="imgAlfredo"
                    animate={{
                        y: [0, -4, 0]
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                />
                <div className="areaTextoContainerInicial">
                   {children}
                </div>
            </div>
    )
}